export enum ChainId {
  // L1
  Ethereum = 1,
  // L1 Testnets
  Local = 1337,
  Sepolia = 11155111,
  // L2
  ArbitrumOne = 42161,
  ArbitrumNova = 42170,
  Base = 8453,
  // L2 Testnets
  ArbitrumSepolia = 421614,
  ArbitrumLocal = 412346,
  BaseSepolia = 84532,
  // L3 Testnets
  L3Local = 333333,
  // Orbit chains
  ApeChain = 33139,
  Superposition = 55244
}
